import { ReactNode } from "react";
import { useSelector } from "react-redux";
import { Box, CircularProgress } from "@mui/material";
import { Store } from "@/store/Store";

/**
 * Gates children (typically RouterProvider) until auth bootstrap completes.
 * This ensures route guards always have bootstrapped auth state and never
 * need to handle the "not yet loaded" case.
 */
function BootstrapGate({ children }: { children: ReactNode }) {
  const currentUser = useSelector((state: Store) => state.auth.currentUser);

  if (!currentUser?.bootstrapped || currentUser?.loading) {
    return (
      <Box sx={{ p: 3, textAlign: "center" }}>
        <CircularProgress color="primary" size={40} />
      </Box>
    );
  }

  return children;
}

export default BootstrapGate;
